<div class="row" *ngIf="Breadcrumb != null">
  <div class="col-12 p-0 border-bottom headersize">
    <app-breadcrumb [Breadcrumb]="Breadcrumb"></app-breadcrumb>
  </div>
</div>
<div class="row border-bottom">
  <!-- <div class="path-class border-b fw-semibold ms-2 my-2">Study Unit Name : {{StudyUnit.Name}}</div> -->
</div>
<div class="row content-add-edit" style="height: 75vh !important; overflow: auto">
  <form [formGroup]="AddStudyMaterialform" class="col-md-12">
    <div class="row"  style="position: relative;">
      <div class="col-md-5" >
        <div class="col-12" *ngIf="StudyMateriallist">
          <div class="row pt-2">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">Study Material Id</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <input type="text" readonly class="form-control form-control-sm w-25" [disabled]="true" [value]="StudyMateriallist?.Study_Material_Id"/>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-2">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Study Material Type</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <select
                formControlName="Study_Material_Type_Code"
                (change)="onStudyMaterialTypeCodeChange($event)"
                (ngModelChange)="Editformvalidation()"
                [disabled]="
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'WIP' &&
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'Rework Suggested'
                "
                class="form-control form-control-sm "
              >
                <option
                  class="border-bottom"
                  [disabled]="
                    AddStudyMaterialform.value
                      .Study_Material_Status_Type_Code != 'WIP' &&
                    AddStudyMaterialform.value
                      .Study_Material_Status_Type_Code != 'Rework Suggested'
                  "
                  *ngFor="let s of getmaterial; let i = index"
                  [value]="s.Code"
                >
                  {{ s.Description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0">Study Material Level</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <select
                formControlName="Study_Material_Level_Type"
                [disabled]="
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'WIP' &&
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'Rework Suggested'
                "
                (ngModelChange)="Editformvalidation()"
                class="form-control form-control-sm "
              >
                <option
                  class="border-bottom"
                  [disabled]="
                    AddStudyMaterialform.value
                      .Study_Material_Status_Type_Code != 'WIP' &&
                    AddStudyMaterialform.value
                      .Study_Material_Status_Type_Code != 'Rework Suggested'
                  "
                  *ngFor="let s of getmateriallevel; let i = index"
                  [value]="s.Code"
                >
                  {{ s.Description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0 text-end">Study Material Name</div>
              </div>
            </div>
            <div class="col-8 pl-2 text-right">
              <input
                type="text"
                [readonly]="
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'WIP' &&
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'Rework Suggested'
                "
                class="form-control form-control-sm "
                formControlName="Study_Material_Name"
                (ngModelChange)="Editformvalidation()"
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0 text-end">Study Material Display Name</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <input
                type="text"
                formControlName="Display_Name"
                class="form-control form-control-sm "
              />
            </div>
          </div>
        </div>
        <!-- *ngIf="
        EditStudyMaterialflag ||
        (!videourlflag &&
          AddStudyMaterialform.value.Study_Material_Type_Code != 'Notes')
      " -->
      </div>

      <div class="col-md-3">
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 text-end">Version Number</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <select
                formControlName="Version_Number"
                class="form-control form-control-sm w-35"
              >
                <option *ngFor="let version of versionOptions" [value]="version">
                  {{ version }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 text-end">Study Material Status</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <input
                type="text"
                formControlName="Study_Material_Status_Type_Code"
                class="form-control form-control-sm "
                [(ngModel)]="StudyMaterialStatus"
                readonly
              />
            </div>
          </div>

        </div>


        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>
                <div class="p-0 text-end">Difficulty Level</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <select
                formControlName="Study_Material_Difficulty_Level_Type"
                class="form-control form-control-sm "
              >
                <option
                  class="border-bottom"
                  *ngFor="let s of courseDifficultyType; let i = index"
                  [value]="s.Code"
                >
                  {{ s.Description }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">Free Resource?</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <input
                type="checkbox"
                formControlName="Free_Resource_Ind"
                class="mt-2"

              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 text-end">Primary Study Material</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <input
                type="checkbox"
                formControlName="PrimaryStudyMaterialInd"
                class="mt-2"

              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-5 text-right pt-1 px-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 text-end">Reference Study Material</div>
              </div>
            </div>
            <div class="col-7 pl-2">
              <input
                type="checkbox"
                formControlName="ReferenceStudyMaterialInd"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">

        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0 d-flex align-items-center justify-content-end">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">File Upload</div>
              </div>
            </div>

            <div class="col-md-8 pl-2" *ngIf="!currentInput || hiddenfilename">
              <div class="d-flex justify-content-start align-items-center ">
                <button
                *ngIf="!(this.AddStudyMaterialform.get('File_Object_Id')?.value && this.AddStudyMaterialform.get('File_Del_Ind')?.value != 'Y') &&!this.AddStudyMaterialform.get('FileUpload')?.value"
                type="button"
                (click)="handleFileButtonClick(fileInput)"
                class="btn btn-sm bg-light border"
                style="height: 100px;"
              >
                Browse
              </button>
                <button
                *ngIf="(this.AddStudyMaterialform.get('File_Object_Id')?.value && this.AddStudyMaterialform.get('File_Del_Ind')?.value != 'Y') || this.AddStudyMaterialform.get('FileUpload')?.value"
                type="button"
                class="btn btn-sm bg-light border"
                style="height: 100px; width: 46%;"
              >
                {{(this.AddStudyMaterialform.get('File_Object_Id')?.value && this.AddStudyMaterialform.get('File_Del_Ind')?.value != 'Y') ? shortenString(AddStudyMaterialform.get('File_Name_In_Server')?.value):shortenString(this.AddStudyMaterialform.get('FileUpload')?.value.name)}}
              </button>
              <input
                #fileInput
                hidden
                (ngModelChange)="Editformvalidation()"
                class="form-control form-control-sm w-75"
                type="file"
                accept="application/pdf,.mov,video/mp4,video/mov,video/x-matroska,.mkv"
                (change)="onChange($event,fileInput)"
              />
              <img
              [src]="'/assets/images/pdf_default.PNG'"
              alt=""
              width="100"
              height="100"
            />
            <div class="d-flex">
              <i
               class="fa fa-trash ms-2  pointer-cursor"
               style="color: red; font-size: 18px;"
               *ngIf="
               (this.AddStudyMaterialform.get('File_Object_Id')?.value && this.AddStudyMaterialform.get('File_Del_Ind')?.value != 'Y')
               "
               (click)="deleteUploadedFileOrFile(fileInput)"></i>
              <i
               class="fa fa-file-pdf-o ms-2  pointer-cursor"
               *ngIf="
               (this.AddStudyMaterialform.get('File_Object_Id')?.value && this.AddStudyMaterialform.get('File_Del_Ind')?.value != 'Y')
               "
               (click)="clickpreviewbutton()"></i>
              <i
               class="fa fa-times ms-2  pointer-cursor"
               *ngIf="this.AddStudyMaterialform.get('FileUpload')?.value"
               (click)="deleteUploadedFileOrFile(fileInput)"></i>
               </div>
            </div>

              <div class="row">
                <div class="col-12">
                  <label class="Valid1" *ngIf="error1.isError">{{
                    error1.errorMessage
                  }}</label>
                  <label class="Valid1" *ngIf="error.isError">{{
                    error.errorMessage
                  }}</label>
                </div>
              </div>
              <div *ngIf="message" class="Valid1">{{ message }}</div>
              <div *ngIf="currentFile" class="progress my-3">
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  attr.aria-valuenow="{{ progress }}"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [ngStyle]="{ width: progress + '%' }"
                >
                  {{ progress }}%
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">File Object Id</div>
              </div>
            </div>
            <div class="col-8 pl-2 text-right">

              <input
                type="text"
                maxlength="100"
                class="form-control form-control-sm w-75 "
                formControlName="File_Object_Id_Temp"
                readonly
              />
            </div>
            <div class="col-2">

            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">File Location</div>
              </div>
            </div>
            <div class="col-8 pl-2 text-right">
              <div class="d-flex gap-2">
                <textarea
                  rows="3"
                  maxlength="100"
                  class="form-control form-control-sm w-75"
                  formControlName="File_Location_NameAndFileName"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
        <div class="row pt-1">
          <div class="col-4 text-right pr-0 pt-1 pl-0">
            <div class="d-flex flex-row-reverse" *ngIf="showStudyMaterialUrl">
              <div class="p-0 text-end">Study Material URL</div>
            </div>
          </div>

          <div class="col-8 pl-2 text-right">
            <div class="d-flex gap-2 align-items-center" *ngIf="showStudyMaterialUrl">
              <textarea
                rows="2"
                maxlength="100"
                class="form-control form-control-sm w-75"
                formControlName="Study_Material_Url"
              ></textarea>

              <!-- Icon: black + centered, opens small window -->
              <a
                *ngIf="AddStudyMaterialform.get('Study_Material_Url')?.value
                  && AddStudyMaterialform.get('Study_Material_Url')?.valid
                "
                class="d-flex align-items-center justify-content-center p-0 text-dark"
                href="#"
                (click)="openStudyMaterialPreview($event)"
                style="width: 32px; height: 32px; text-decoration: none;"
              >
                <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>

            <small style="color:red;" *ngIf="AddStudyMaterialform.get('Study_Material_Url')?.invalid">Please enter a valid URL starting with http:// or https:// </small>
          </div>
        </div>
        </div>



        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 text-end ">Number of Pages</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <input
              type="text"
              formControlName="NumberOfPages"
              appNumericInput
              [disabled]="AddStudyMaterialform.get('Study_Material_Type_Code')?.value === 'ClassVideo'"
              class="form-control form-control-sm text-end w-35"
              [max]="9999"
            />

            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row pt-1">
            <div class="col-4 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse"><div class="p-0 label-red">*</div>

                <div class="p-0">Duration In Minutes</div>
              </div>
            </div>
            <div class="col-8 pl-2">
              <input
                type="number"
                appNumericInput
                formControlName="Duration_In_Minutes"
                class="form-control form-control-sm text-end w-35 "
                [max]="9999"
              />
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="!showStudyMaterialUrl" style="height:43px"></div>
      </div>
      <div class="col-md-10" style="position: absolute; top: 235px;">
        <div class="col-12 text-right">
          <div class="row pt-2">
            <div class="col-2 text-right pr-0 pt-1 pl-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0">Description</div>
              </div>
            </div>
            <div class="col-10">
              <!-- [readonly]="
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'WIP' &&
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'Rework Suggested'
                "
                [disabled]="
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'WIP' &&
                  AddStudyMaterialform.value.Study_Material_Status_Type_Code !=
                    'Rework Suggested'
                " -->
              <textarea
                formControlName="Description_Text"
                (ngModelChange)="Descriptioncount()"
                maxlength="4000"
                [rows]="5"
                class="form-control w-75"
                id="txtAssignmentIntruction"
              ></textarea>
              <label class="form-check-label maxlength" for="exampleCheck1"
                >Characters {{ Descriptionvaluelength }}/{{
                  DescriptionMaxlength
                }}</label
              >
            </div>

          </div>
        </div>
      </div>
      <!-- ACTION BUTTONS START -->
      <div class="mb-3 row" style="margin-top: 58px;">
        <div class="col-12 d-flex flex-wrap justify-content-between align-items-start gap-2">

          <!-- LEFT SIDE BUTTON WRAPPER -->
          <div class="d-flex flex-wrap gap-2">

            <!-- Preview Button -->
            <!-- <div *ngIf="AddStudyMaterialflag || EditStudyMaterialflag">
              <button
                type="button"
                (click)="clickpreviewbutton()"
                class="btn btn-sm bg-light border"
              >
                Preview
              </button>
            </div> -->

            <!-- Submit for Review (Add) -->
            <div
              *ngIf="AddStudyMaterialflag"
              [hidden]="
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'WIP' &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'Rework Suggested'
              "
            >
              <button
                type="button"
                class="btn btn-sm bg-light border"
                [disabled]="AddStudyMaterialflag"
                (click)="AddSubmitReview('Submitted')"
              >
                Submit for Review
              </button>
            </div>

            <!-- Submit for Review (Edit) -->
            <div
              *ngIf="
                EditStudyMaterialflag &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'Submitted for Review' &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'Under Review' &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'Approved' &&
                StudyMaterialDetails.Study_Material_Status_Type_Code !== 'Submitted'
              "
              [hidden]="
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'WIP' &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code !== 'Rework'
              "
            >
              <button
                type="button"
                class="btn btn-sm bg-light border"
                [disabled]="
                  AddStudyMaterialform.get('Study_Material_Status_Type_Code')?.value !== 'WIP' ||
                  (
                    !AddStudyMaterialform.get('File_Location_Name')?.value &&
                    !AddStudyMaterialform.get('Study_Material_Url')?.value
                  )
                "
                (click)="AddSubmitReview('Submitted')"
              >
                Submit for Review
              </button>
            </div>

            <!-- Review Button -->
            <div
              *ngIf="
                EditStudyMaterialflag &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code === 'Submitted'
              "
            >
              <button
                type="button"
                class="btn btn-sm bg-light border"
                (click)="ClkReviewButton('Under Review')"
              >
                Review
              </button>
            </div>

            <!-- Continue Review Button -->
            <div
              *ngIf="
                EditStudyMaterialflag &&
                AddStudyMaterialform.value.Study_Material_Status_Type_Code === 'Under Review'
              "
            >
              <button
                type="button"
                class="btn btn-sm bg-light border"
                (click)="ClkReviewButton('Under Review')"
              >
                Continue Review
              </button>
            </div>

            <!-- Assign Practice Questions and Related Topics -->
            <div *ngIf="this.StudyMateriallist" class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm bg-light border"
                (click)="AssignPracticeQuestions()"
              >
                Assign Practice Questions
              </button>
              <button
                type="button"
                class="btn btn-sm bg-light border"
                (click)="ManageRelatedTopics()"
              >
                Manage Related Topics
              </button>
            </div>

          </div>
          <!-- END LEFT SIDE -->

          <!-- RIGHT SIDE BUTTON WRAPPER -->
          <div class="d-flex flex-wrap gap-2 me-3">
                  <div >
              <button
                type="button"
                class="btn btn-sm bg-light border"
                (click)="OnClose()"
              >
                Cancel
              </button>
            </div>
            <!-- Save Button (Add) -->
            <div *ngIf="AddStudyMaterialflag">
              <button
                type="button"
                [disabled]="!hasFormChangedForMainForm()"
                (click)="AddStudyMaterial()"
                class="btn btn-sm bl-btn"
              >
                Save
              </button>
            </div>

            <!-- Save Button (Edit) -->
            <div *ngIf="EditStudyMaterialflag">
              <button
                type="button"
                [disabled]="!hasFormChangedForMainForm()"
                (click)="AddStudyMaterial()"
                class="btn btn-sm bl-btn"
              >
                Save
              </button>
            </div>

          </div>
          <!-- END RIGHT SIDE -->

        </div>
      </div>
      <!-- ACTION BUTTONS END -->


<div class="col-12" *ngIf="this.StudyMateriallist">
  <div class="row">
    <div class="col-12 bg-head">
      <h3 class="my-1">Applicable Course Type</h3>
    </div>

    <div class="col-12 mt-1">
      <div class="row">
        <div
          class="d-flex flex-wrap gap-3"
          formArrayName="Course_Category_Type"
        >
          <div
            *ngFor="
              let ccType of getFormControlsByName('Course_Category_Type')
                ?.controls;
              let i = index
            "
          >
            <div [formGroup]="ccType">
              <input
                type="checkbox"
                formControlName="SelectedInd"
                (change)="onCourseCategoryTypeChange($event, ccType)"
              />
              {{ ccType.value.CourseCategoryTypeName }}
            </div>
          </div>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-12 bg-head">
          <h3>Applicable Courses</h3>
        </div>
        <div
          class="px-1 d-flex justify-content-between mt-2 align-items-centers"
          *ngIf="this.StudyMateriallist"
        >
        <span>
          <small class="text-danger">Study Material can be assigned to Course Plans if the Course's Availability End Date is greater than the current date</small>
        </span>
          <button
            type="button"
            (click)="AssigntoCourses()"
            [disabled]="!hasFormChangedForMApplicableCourseForm()"
            class="btn btn-sm bl-btn me-5"
          >
            Save Study Material Assignment
          </button>
        </div>
      </div>

      <ng-container *ngFor="let item of courseCategoryList">
        <div class="row my-3" *ngIf="isActivated(item.Code)">
          <div class="col-12">
            <div class="d-flex align-items-baseline gap-3">
              <h4>{{ item.Description }}</h4>
              <i
                class="fa fa-plus pointer-cursor"
                (click)="
                  addApplicableExamList(
                    { type: item.Code },
                    getFormControlsByName('Applicable_Exam_List', item)?.controls
                  )
                "
              ></i>
            </div>
          </div>

          <div class="col-12">
            <!-- SCROLL CONTAINER FOR HEADER + ROWS -->
            <div class="course-plan-scroll">
              <!-- HEADER ROW -->
              <div class="row px-2" *ngIf="CheckIfCourseType(item.Code)">
                <div class="col-md-3 col-lg-2 col-xxl-2 px-1">
                  <span class="position-relative">
                    Exam Agency
                    <small
                      class="text-danger fs-5 position-absolute bottom-0"
                      >*</small
                    >
                  </span>
                </div>
                <div class="col-md-3 col-lg-2 col-xxl-2 px-0">
                  <span class="position-relative">
                    Course Name
                    <small
                      class="text-danger fs-5 position-absolute bottom-0"
                      >*</small
                    >
                  </span>
                </div>
                <div class="col-md-3 col-lg-2 col-xxl-1 px-0">
                  <span class="position-relative">
                    Year / Month
                    <small
                      class="text-danger fs-5 position-absolute bottom-0"
                      >*</small
                    >
                  </span>
                </div>
                <div class="col-md-3 col-lg-6 col-xxl-6 px-0">
                  <div class="row plan-row flex-nowrap">
                    <!-- <div class="col-2 text-center" >All Plans</div> -->
                    <div
                      class="col-2 col-xxl-2 text-center px-0"
                      *ngFor="let cp of this.COURSE_PLAN_TYPE"
                    >
                      {{ cp.Description }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- BODY ROWS -->
              <div class="row px-2" formArrayName="Applicable_Exam_List">
                <ng-container
                  *ngFor="
                    let appExam of getFormControlsByName(
                      'Applicable_Exam_List',
                      item
                    )?.controls;
                    let i = index
                  "
                >
                  <div
                    class="row my-1"
                    [formGroup]="appExam"
                    *ngIf="
                      appExam.value.type === item.Code &&
                      appExam.get('deleteInd')?.value === 'N'
                    "
                  >
                    <div class="col-md-3 col-lg-2 col-xxl-2 px-1">
                      <select
                        class="form-control"
                        formControlName="examAgency"
                        (change)="fetchCourseBasedOnExam(appExam, item)"
                      >
                        <option [value]="null" hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let s of appExam.value.examAgencyList"
                          [value]="s.Code"
                        >
                          {{ s.Description }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3 col-lg-2 col-xxl-2 px-1">
                      <select
                        class="form-control"
                        formControlName="courseId"
                        (change)="fetchCourseYear(appExam, item)"
                      >
                        <option [value]="null" hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let s of appExam.value.courseList"
                          [value]="s.Code"
                        >
                          {{ s.Description }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3 col-lg-2 col-xxl-1 px-1">
                      <select
                        class="form-control"
                        formControlName="examYear"
                        (change)="getCoursePlan(i)"
                      >
                        <option [value]="null" hidden></option>
                        <option
                          class="border-bottom"
                          *ngFor="let s of appExam.value.courseYear"
                          [value]="s.Code"
                        >
                          {{ s.Description }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3 col-lg-6 col-xxl-6">
                      <div
                        class="row h-100 d-flex align-items-center plan-row flex-nowrap"
                      >
                        <div
                          *ngFor="
                            let cpItem of this.COURSE_PLAN_TYPE;
                            let cp = index
                          "
                          class="col-2 col-xxl-2 px-0 text-center position-relative"
                        >
                          <input
                            type="checkbox"
                            (change)="
                              updateSelectedCoursePlan(
                                cpItem,
                                appExam,
                                $event
                              )
                            "
                            [checked]="
                              isCoursePlanSelected(appExam, cpItem.Code)
                            "
                            [disabled]="checkIfEnabled(cpItem, appExam)"
                          />
                          <i
                            *ngIf="cp === COURSE_PLAN_TYPE.length - 1"
                            class="fa fa-trash position-absolute end-0 top-0 pointer-cursor"
                            (click)="deleteApplicablecourse(appExam)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- /course-plan-scroll -->
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

    </div>
  </form>
</div>


